'use client'
import Link from 'next/link'

import { clsx } from 'clsx'

import { FC } from 'react'

import { generateIcon } from '@/app/shared/components/messengers/services'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import useLayout from '@/app/shared/store/layout.store'

// interface
interface IMessengers extends IClassName {
  modal?: boolean
}

const MessengersComponent: FC<Readonly<IMessengers>> = ({ className, modal }) => {
  const messengers = useLayout((state) => state.socials)
  return (
    <ul
      className={clsx('messengers flex items-center', className, {
        'gap-2.5 laptop:gap-5': modal,
        'gap-5': !modal,
      })}
    >
      {messengers.map((el, index) => (
        <li key={`${el?.key}_${index}`}>
          <Link href={el?.value ?? ''} target={'_blank'}>
            <span
              className={
                'flex h-[42px] w-[42px] items-center justify-center rounded-full bg-white transition-background hover:bg-warning hover:text-warning lg:h-[32px] lg:w-[32px] xl:h-[42px] xl:w-[42px]'
              }
            >
              {generateIcon(el?.key ?? '', 'w-full h-full text-inherit transition-colors')}
            </span>
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default MessengersComponent
